module.exports = __webpack_public_path__ + "assets/img/5f59-bi.svg";